import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { PostsList } from './PostsList';
import { posts } from '../services/posts';
import { fromSeoFriendlyUrl } from '../utils/urlHelpers';

export const TagView: FC = () => {
  const { tagId } = useParams();
  
  const decodedTag = fromSeoFriendlyUrl(tagId);
  
  const filteredPosts = posts.filter(
    post => post.tags.includes(decodedTag)
  );
  
  return <PostsList posts={filteredPosts} />;
}; 